export const sceneMap = {
  normal: {
    title: 'QQ浏览器，4亿人的工具学习神器',
    image:
      'https://smpimg-1258344701.file.myqcloud.com/smp-ldp/qb-wap-page/static/image/normal.jpg',
    appStore:
      'https://itunes.apple.com/app/apple-store/id370139302?pt=69276&ct=1100125135&mt=8',
    downloadUrl:
      'https://mdc.html5.qq.com/directdown?app=qqbrowser&channel=1100125135',
    deeplink:
      'mttbrowser://url=qb://searchresult?pagetype=sogou_result&sogouUrl=https%3A%2F%2Fm.sogou.com%2Fweb%2FsearchList.jsp%3Fkeyword%3D&q=__SEARCH_QUERY__&jump_from=1_07_55_05,ChannelID=sgwap_lh,PosID=92111',


  },
  novel: {
    title: 'QQ浏览器，海量正版小说免费看',
    image:
      'https://smpimg-1258344701.file.myqcloud.com/smp-ldp/qb-wap-page/static/image/novel.jpg',
    appStore:
      'https://itunes.apple.com/app/apple-store/id370139302?pt=69276&ct=1100125158&mt=8',
    downloadUrl:
      'https://mdc.html5.qq.com/directdown?app=qqbrowser&channel=1100125158',
    deeplink:
      'mttbrowser://url=qb://searchresult?pagetype=sogou_result&sogouUrl=https%3A%2F%2Fm.sogou.com%2Fweb%2FsearchList.jsp%3Fkeyword%3D&q=__SEARCH_QUERY__&jump_from=1_07_55_06,ChannelID=sgwap_lh,PosID=92140',
  },
  video: {
    title: 'QQ浏览器，热综热剧电影在线追',
    image:
      'https://smpimg-1258344701.file.myqcloud.com/smp-ldp/qb-wap-page/static/image/video.jpg',
    appStore:
      'https://itunes.apple.com/app/apple-store/id370139302?pt=69276&ct=1100125176&mt=8',
    downloadUrl:
      'https://mdc.html5.qq.com/directdown?app=qqbrowser&channel=1100125176',
    deeplink:
      'mttbrowser://url=qb://searchresult?pagetype=sogou_result&sogouUrl=https%3A%2F%2Fm.sogou.com%2Fweb%2FsearchList.jsp%3Fkeyword%3D&q=__SEARCH_QUERY__&jump_from=1_07_55_06,ChannelID=sgwap_lh,PosID=92141',
  },
};


// mttbrowser://url=qb://searchresult?pagetype=sogou_result&sogouUrl=https%3A%2F%2Fm.sogou.com%2Fweb%2FsearchList.jsp%3Fkeyword%3D&q=__SEARCH_QUERY__&jump_from=1_07_55_06,ChannelID=sgwap_lh,PosID=92141
// mttbrowser://url=https://sl.m.sogou.com/web/searchList.jsp?keyword=__SEARCH_QUERY__&jump_from=1_07_55_05,ChannelID=sgwap_lh,PosID=92111
